import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ISave = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width??"17"}
            height={props.height??"18"}
            viewBox="0 0 17 18"
            fill="none"
          >
            <path
              d="M3.93091 0.859375V7.53873H11.9052V0.859375"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <path
              d="M12.7229 0.927734H1V17.1432H16.1989V4.40372L12.7229 0.927734Z"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <line
              x1="3.6582"
              y1="11.2363"
              x2="12.3823"
              y2="11.2363"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <line
              x1="3.6582"
              y1="14.5078"
              x2="12.3823"
              y2="14.5078"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ISave;
